import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

// Extend dayjs with necessary plugins
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(relativeTime);

// Extended version of dayjs with plugins & proper types.
export default dayjs;
